import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Grid,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { useAuth } from "../../../context/AuthContext";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";

export default function ContractListPage() {
  useProtectedRoute();
  const { token } = useAuth();
  const navigate = useNavigate();

  const [contracts, setContracts] = useState<any[]>([]);

  useEffect(() => {
    const fetchContracts = async () => {
      try {
        const res = await api.get("/contracts", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setContracts(res.data);
      } catch {
        alert("Failed to load contracts");
      }
    };

    fetchContracts();
  }, [token]);

  const formatDate = (date: string) =>
    new Date(date).toLocaleDateString();

  return (
    <Box p={4}>
      <Grid container justifyContent="space-between" alignItems="center" mb={3}>
        <Grid item>
          <Typography variant="h4" fontWeight="bold" color="primary">
            Contracts
          </Typography>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Add />}
            onClick={() => navigate("/contracts/create")}
          >
            New Contract
          </Button>
        </Grid>
      </Grid>

      <TableContainer component={Paper} elevation={2}>
        <Table size="small">
          <TableHead sx={{ backgroundColor: "#f3f4f6" }}>
            <TableRow>
              <TableCell><strong>Employee ID</strong></TableCell>
              <TableCell><strong>Start Date</strong></TableCell>
              <TableCell><strong>End Date</strong></TableCell>
              <TableCell><strong>Salary</strong></TableCell>
              <TableCell><strong>Status</strong></TableCell>
              <TableCell><strong>Created At</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contracts.map((contract) => (
              <TableRow key={contract._id} hover>
                <TableCell>{contract.employeeId}</TableCell>
                <TableCell>{formatDate(contract.startDate)}</TableCell>
                <TableCell>
                  {contract.endDate ? formatDate(contract.endDate) : "—"}
                </TableCell>
                <TableCell>${contract.salary?.toFixed(2)}</TableCell>
                <TableCell>
                  <Chip
                    label={contract.status}
                    size="small"
                    sx={{
                      backgroundColor:
                        contract.status === "active"
                          ? "#10b981"
                          : "#ef4444",
                      color: "white",
                      fontWeight: 600,
                      textTransform: "capitalize",
                    }}
                  />
                </TableCell>
                <TableCell>{formatDate(contract.createdAt)}</TableCell>
              </TableRow>
            ))}
            {contracts.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No contracts found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
